const emptyObject = {}

export const selectAttachmentsByTicketId = state =>
  state.attachments.byTicketId || emptyObject
